/**
 * @file sales-rep.ts
 * @module api/apiJSON/sales-rep
 * @description Defines sales rep API request configuration and payload helpers.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { IAddEditTarget, IListTargets } from "../../types";

export const assistAdminJson = {
  list: (data: IListTargets) => {
    let params: any = {
      pageNo: data.pageNo,
      limit: data.limit,
      searchTerm: data.searchTerm ? data.searchTerm : "",
      needCount: true,
    };
    if (data.targetType) {
      params.targetType = data.targetType;
    }
    return params;
  },
  addAssistAdmin: (data: any) => {
    let form = new FormData();
    form.append("name", data.name);
    form.append("email", data.email);
    form.append("phoneCountry", data.phoneCountry);
    form.append("phone", data.phone);
    form.append("role[0][type]", data.type);
    if (data.type === 1 && data.districts && data.districts.length > 0) {
      data.districts.forEach((districtId: string, index: number) => {
        form.append(`districts[${index}]`, districtId);
      });
    }
    if ((data.type === 2 || data.type === 7) && data.manager) {
      form.append("manager", data.manager);
    }
    if (data.image) {
      form.append("image", data.image);
    }
    return form;
  },
  editAssistAdmin: (data: any) => {
    let form = new FormData();
    form.append("name", data.name);
    form.append("email", data.email);
    form.append("phoneCountry", data.phoneCountry);
    form.append("phone", data.phone);
    form.append("role[0][type]", data.type);
    if (data.type === 1 && data.districts && data.districts.length > 0) {
      data.districts.forEach((districtId: string, index: number) => {
        form.append(`districts[${index}]`, districtId);
      });
    }
    if ((data.type === 2 || data.type === 7) && data.manager) {
      form.append("manager", data.manager);
    }
    if (data.image) {
      form.append("image", data.image);
    }
    return form;
  },
};
